import { HTMLAttributes } from "react";
import { VariantProps } from "class-variance-authority";
import { cn } from "@/src/lib/utils";
import { Text } from "@/src/components/ui/Typography";
import { tagVariants } from "./tagVariants";

interface TagProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof tagVariants> {}

export function Tag({ variant, className, children, ...props }: TagProps) {
  return (
    <Text
      as="span"
      size="labelLG"
      className={cn(tagVariants({ variant }), className)}
      {...props}
    >
      {children}
    </Text>
  );
}
